/// @ts-ignore
import { PixiPlugin } from "gsap/all";
import { Howler } from "howler";
import { Application } from "./scripts/Application";
const pixiPlugin = PixiPlugin;
Howler.autoUnlock = false;
const canvasDiv = document.createElement("div");
canvasDiv.setAttribute("id", "gameTarget");
document.body.appendChild(canvasDiv);
canvasDiv.appendChild(Application.instance.view);

Application.instance.init();
